/* eslint-disable perfectionist/sort-union-types */
'use client';
import { useEffect, useState } from 'react';

import { useMounted } from '@shared/utils/hooks/use-mounted';

import { Loader } from '../../components/loader/loader';

import styles from './omnichannel-chat-block.module.scss';

export type OmnichannelChatBlockProps = {
  chatUrl: string;
};

export const OmnichannelChatBlock = ({ chatUrl }: OmnichannelChatBlockProps) => {
  const [userId, setUserId] = useState<string | null>(null);
  const [conversationId, setConversationId] = useState<string | null>(null);
  const isMounted = useMounted();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setUserId(urlParams.get('userid'));
    setConversationId(urlParams.get('conversationid'));
  }, []);

  const chatUrlWithParams = `${chatUrl}?userid=${userId}&conversationid=${conversationId}`;

  if (!isMounted) {
    return <Loader isInner />;
  }

  return (
    <div className={styles['omnichannel-chat-wrapper']}>
      {userId && conversationId ? (
        // using allow-scripts and allow-same-origin is generally not recommended,
        // but is necessary for the chat to function properly. We control the content being loaded in the iframe.
        // eslint-disable-next-line react/iframe-missing-sandbox
        <iframe
          height="1000px"
          sandbox="allow-scripts allow-same-origin allow-downloads allow-forms"
          src={chatUrlWithParams}
          width="100%"
        />
      ) : (
        <div className={styles['error-message']}>Error loading chat</div> // TODO: Replace with CMS content
      )}
    </div>
  );
};
